module.exports = __webpack_public_path__ + "static/abstract01-7553bff813375517551a862d423ab19e.jpg";